// 기준 로케일. 이 파일의 키 집합이 TranslationKey 타입의 원천이므로,
// 여기에 키를 추가하면 ko.ts / ja.ts 에도 채워야 컴파일이 통과한다.
const en = {
  Name: 'Name',
  Room: 'Room',
  Join: 'Join',
  BillingNotice: 'You will be charged even if you join before your reserved time. Please join at your reserved time.',
  MuteAudio: 'Mute Audio',
  UnmuteAudio: 'Unmute Audio',
  MuteVideo: 'Mute Video',
  UnmuteVideo: 'Unmute Video',
  ShareScreen: 'Share Screen',
  StopSharingScreen: 'Stop Sharing Screen',
  ShareInProgress: 'Cannot share screen when another user is sharing',
  ShareNotSupported: 'Screen sharing is not supported with this browser',
  EndCall: 'End Call',
};

// 번역 키 목록. ko.ts / ja.ts 가 이 타입으로 선언되므로 키를 빠뜨리면 컴파일 에러가 난다.
export type TranslationKey = keyof typeof en;

export default en;
